import type { TOpinionDateType } from '../types';

export function getTimelineTimeFormat(dateType?: string): string {
  return dateType === 'hourly' ? 'YYYY-MM-DD HH:mm:ss' : 'YYYY-MM-DD';
}

export function normalizeOpinionDateType(
  dateType?: string,
): TOpinionDateType {
  switch (dateType) {
    case 'hourly':
    case 'hour':
      return 'hourly';
    case 'weekly':
    case 'week':
      return 'weekly';
    case 'monthly':
    case 'month':
      return 'monthly';
    default:
      return 'daily';
  }
}
